export const CREATED = 1;

export const UPDATED = 2;

export const DELETED = 3;
